import { render } from "./SortButton.vue?vue&type=template&id=0787a340&scoped=true&ts=true"
import script from "./SortButton.vue?vue&type=script&lang=tsx"
export * from "./SortButton.vue?vue&type=script&lang=tsx"

import "./SortButton.vue?vue&type=style&index=0&id=0787a340&scoped=true&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0787a340"]])

export default __exports__